import { gql } from '@apollo/client';

export const GET_CLIENTS = gql`
{
    Clients {
        _id
        company_name
    }
}
`;